
const ImportFileTypes = Object.freeze({
  CSV: 'CSV',
  XLSX: 'XLSX (Excel)',
  XLS: 'XLS'
})

export default ImportFileTypes
